module.exports = __webpack_public_path__ + "media/images/flags/mn-3868005de3792f462620d83e1ce12174.svg";